import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Kanban, Users2, Wallet, Trophy, PieChart, Trash2, MessagesSquare, FileText, Sparkles } from "lucide-react";

const STEPS = [
  { icon: Sparkles, title: "Selamat datang di Equity CRM! 👋", desc: "Tur singkat ini mengenalkan semua fitur. Bisa dilewati kapan saja, dan diulang lewat halaman Panduan." },
  { icon: LayoutDashboard, title: "Dashboard", desc: "Ringkasan performa: total leads, omset, piutang, closing rate, funnel & aging. Filter per bulan/tahun/cabang." },
  { icon: Kanban, title: "Pipeline", desc: "Geser kartu antar tahap (Konsultasi → SPH → Closing → Lost). Ada tanggal masuk & filter periode. Tampilan Kanban / daftar." },
  { icon: Users2, title: "Leads", desc: "Semua data client. Mode kartu / tabel Excel. Filter status termasuk SPH & Tidak Jelas. Deteksi duplikat otomatis saat input." },
  { icon: FileText, title: "Dokumen (Quotation & Invoice)", desc: "Buat Quotation/SPH & Invoice langsung dari detail client, auto-isi data, edit bebas, simpan riwayat, cetak PDF." },
  { icon: Wallet, title: "Piutang", desc: "Rekap sisa tagihan tiap client closing, umur piutang, dan status lunas." },
  { icon: Trophy, title: "Leaderboard", desc: "Peringkat sales bulanan + badge. Data client tiap sales tetap privat." },
  { icon: PieChart, title: "Insight", desc: "Analisa channel, kategori customer, dan akar masalah Lost Order + saran solusi." },
  { icon: Trash2, title: "Data Sampah", desc: "Lead mandek 60 hari kerja pindah ke sini otomatis — bisa di-restore satuan atau massal." },
  { icon: MessagesSquare, title: "Chat Tim", desc: "Diskusi antar admin, sales & owner. Tanya kabar client, kendala, saling mengingatkan." },
];

export default function Tour({ open, onClose }) {
  const [i, setI] = useState(0);
  useEffect(() => { if (open) setI(0); }, [open]);
  if (!open) return null;
  const s = STEPS[i]; const Icon = s.icon; const last = i === STEPS.length - 1;
  const finish = () => { localStorage.setItem("crm_tour_done", "1"); onClose(); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && finish()}>
      <DialogContent className="bg-[#0f0f12] border-white/10 max-w-md" data-testid="tour-dialog">
        <DialogTitle className="sr-only">{s.title}</DialogTitle>
        <DialogDescription className="sr-only">Tur pengenalan fitur Equity CRM</DialogDescription>
        <div className="text-center py-2">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-tr from-blue-700 to-blue-900 flex items-center justify-center mx-auto mb-4"><Icon className="text-white" size={26} /></div>
          <h2 className="font-heading font-bold text-lg mb-2">{s.title}</h2>
          <p className="text-sm text-zinc-400">{s.desc}</p>
          <div className="flex justify-center gap-1.5 my-4">
            {STEPS.map((_, idx) => <span key={idx} className={`h-1.5 rounded-full transition-all ${idx === i ? "w-5 bg-blue-500" : "w-1.5 bg-white/15"}`} />)}
          </div>
          <div className="flex gap-2">
            <Button data-testid="tour-skip" variant="outline" onClick={finish} className="flex-1 h-10 bg-[#18181B] border-white/10">Lewati</Button>
            {last ? (
              <Button data-testid="tour-finish" onClick={finish} className="flex-1 h-10 bg-gradient-to-r from-blue-700 to-blue-900">Selesai</Button>
            ) : (
              <Button data-testid="tour-next" onClick={() => setI(i + 1)} className="flex-1 h-10 bg-gradient-to-r from-blue-700 to-blue-900">Lanjut</Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
